export default "__VITE_ASSET__BkpR$Aqb__"